/**
 * Parse a MediaDataBox from an IsoView
 *
 * @param view - The IsoView to read data from
 *
 * @returns A parsed MediaDataBox
 *
 * @group ISOBMFF
 *
 * @beta
 */
export function mdat(view) {
    return {
        data: view.readData(-1),
    };
}
;
//# sourceMappingURL=mdat.js.map